import styled from '../../styles/styled-components';

export const Paper = styled.div`
  position: relative;
  padding: 20px;
  background-color: white;
  box-shadow: 2px 2px 10px 0 rgba(0, 0, 0, 0.1),
    2px 2px 10px 0 rgba(101, 69, 167, 0.3);
`;
